import { combineReducers } from "redux";

const userCompanies = (state = [], action) => {
    switch (action.type) {
        case "USER_COMPANIES":
            state = action.payload;
            return state;
        default:
            return state;
    }
}

const userRole = (state = [], action) => {
    switch (action.type) {
        case "SET_USER_ROLE":
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default combineReducers({
    userCompanies,
    userRole,
});
